import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { UsersPage } from "@/features/users/pages/users-page";
import { userFilterSchema } from "@/features/users/schemas/user-filter.schema";

export const Route = createFileRoute("/_authenticated/admin/users/")({
	head: () => pageTitle("Users"),
	component: UsersPage,
	validateSearch: zodValidator(userFilterSchema),
});
